import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { MessageService } from '../message.service';
import { ProcessDefinition } from '../process-definition';
import { ProcessInstance } from '../process-instance';
import { QueryMetaData} from '../query-metadata';
import { RepoService } from '../repo.service';
import { environment } from '../../environments/environment';
import { PaginationComponent } from '../pagination/pagination.component';

@Component({
    selector: 'app-proc-def',
    templateUrl: './proc-def-list.component.html',
    styleUrls: ['./proc-def-list.component.scss'],
    standalone: true,
    imports: [RouterModule, PaginationComponent]
})
export class ProcDefComponent implements OnInit {

  procDefs: ProcessDefinition[];
  selectedProcDef: ProcessDefinition;
  procInst: ProcessInstance;
  queryObj: QueryMetaData;

  private route: ActivatedRoute = inject(ActivatedRoute);
  private repoService: RepoService = inject(RepoService);
  private messageService: MessageService = inject(MessageService);

  ngOnInit(): void {
    this.route.queryParamMap
      .subscribe((params) => {
               const start = params.get('start') === null ? 0 : parseInt(params.get('start'));
               const size = params.get('size') === null ? environment.pageSize : parseInt(params.get('size'));
        this.queryObj = { start, size } as QueryMetaData;
        this.getProcessDefinitions(this.queryObj);
      }
    );
  }

  getProcessDefinitions(query: QueryMetaData): void {
    this.repoService.getProcessDefinitions(query)
        .subscribe(procDefs => this.procDefs = procDefs);
  }

  /** Start process instance without any inputs (no start form) */
  onSelect(procDef: ProcessDefinition): void {
    this.selectedProcDef = procDef;
    this.messageService.set(`Process definition selected id=${procDef.id}`);
    //this.repoService
    //  .startInstance(procDef.id)
    //  .subscribe(procInst => this.procInst = procInst);
  }
}
